export class PayMemoPeoplesoftExport {
    unit: string;
    ledger: string;
    account: string;
    productCode: string;
    currency: string;
    amount: string;
    accountDescription: string;
}
